import styled from 'styled-components'

export const AssetsTitleSection = styled.div`
	margin-top: 40px;
	font-size: 30px;
	font-weight: 400;
	letter-spacing: 1px;
	color: ${p => p.theme.COLORS.textw};
`
